import { sendStreamingStatistics } from '@api/streaming/streaming-stats';
import type { StreamingStats } from '@api/types';

export class Stats {
    private toSend: StreamingStats[] = [];
    private interval: number | null = null;

    sendDataInterval: number;

    constructor() {
        this.sendDataInterval = 5000;
    }

    private async sendData() {
        if (this.toSend.length > 0) {
            const statsData = this.toSend;

            this.toSend = [];

            try {
                await sendStreamingStatistics({ statsData });
            } catch (e) {
                console.error(e);
            }
        }
    }

    private startCollectingData() {
        if (!this.interval) {
            this.interval = window.setInterval(() => this.sendData(), this.sendDataInterval);
        }
    }

    public addToBatch(data: StreamingStats) {
        this.startCollectingData();

        this.toSend.push(data);
    }
}

export const streamingStats = new Stats();
